import { useCallback, useMemo } from "react";
import { $staffApi } from "../api";

export type SegmentNameData = {
  segment_key: string;
  display_name: string;
};

export function useSegments(): {
  segments: SegmentNameData[] | null;
  defaultSegment: string | null;
  isLoading: boolean;
  getSegmentDisplayName: (segmentKey: string) => string;
} {
  const { data, isLoading } = $staffApi.useQuery("get", "/api/segments/");

  const segments = useMemo(() => {
    if (!data) return null;
    const displayName = "display_name";
    return Object.keys(data.segments).map((key) => ({
      segment_key: key,
      display_name: displayName in data.segments[key] ? data.segments[key][displayName] : key,
    }));
  }, [data]);

  const defaultSegment = data?.default_segment ?? null;

  const getSegmentDisplayName = useCallback(
    (segmentKey: string): string => {
      return segments?.find((s) => s.segment_key === segmentKey)?.display_name ?? segmentKey;
    },
    [segments]
  );

  return {
    segments,
    defaultSegment,
    isLoading,
    getSegmentDisplayName,
  };
}
